export function download() {
  console.log(11111)
  const anchor = document.createElement('a');
  // anchor.href = `https://www.oopz.cn/download/xx?v=${Date.now()}`;
 
  anchor.href = `https://www.oopz.cn/download/xx?v=${Date.now() /1000 |0}`;

  // Append to the DOM
  document.body.appendChild(anchor);

  // Trigger `click` event
  anchor.click();

  // Remove element from DOM
  document.body.removeChild(anchor);
}


export function toWeb() {
  const anchor = document.createElement('a');
  anchor.href = `https://web.oopz.cn`;

  // Append to the DOM
  document.body.appendChild(anchor);

  // Trigger `click` event
  anchor.click();

  // Remove element from DOM
  document.body.removeChild(anchor);
}


export function iterms() {
  const anchor = document.createElement('a');
  console.log(1)
  anchor.href = 'https://www.oopz.cn/agreement/service';

  // Append to the DOM
  document.body.appendChild(anchor);

  // Trigger `click` event
  anchor.click();

  // Remove element from DOM
  document.body.removeChild(anchor);
}

export function privacy() {
  const anchor = document.createElement('a');
  anchor.href = 'https://www.oopz.cn/agreement/privacy';

  // Append to the DOM
  document.body.appendChild(anchor);

  // Trigger `click` event
  anchor.click();

  // Remove element from DOM
  document.body.removeChild(anchor);
}
export function introduce() {
  const anchor = document.createElement('a');
  anchor.href = 'https://www.oopz.cn/product';

  // Append to the DOM
  document.body.appendChild(anchor);

  // Trigger `click` event
  anchor.click();

  // Remove element from DOM
  document.body.removeChild(anchor);
}

export function security() {
  const anchor = document.createElement('a');
  anchor.href = 'https://beian.mps.gov.cn/#/query/webSearch?code=33060302001220';

  // Append to the DOM
  document.body.appendChild(anchor);

  // Trigger `click` event
  anchor.click();

  // Remove element from DOM
  document.body.removeChild(anchor);
}